module.exports = __webpack_public_path__ + "media/dashboard/assets/images/leader_board-95d6cfea683161a113a7db60c0550551.png";